import React from 'react';
import RPullToRefresh from 'rmc-pull-to-refresh';
import Icon from '../icon';
export default class PullToRefresh extends React.Component {
    render() {
        const ind = Object.assign({ release: <Icon type="loading"/> }, this.props.indicator);
        return <RPullToRefresh {...this.props} indicator={ind}/>;
    }
}
PullToRefresh.defaultProps = {
    prefixCls: 'am-pull-to-refresh',
};



// WEBPACK FOOTER //
// ./components/pull-to-refresh/index.tsx